import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  toggle(event) {
    event.preventDefault()
    if (!this.hasInputTarget) return

    const shown = this.inputTarget.type === 'text'
    this.inputTarget.type = shown ? 'password' : 'text'
  }
}
